import { render, staticRenderFns } from "./BusinessMembersView.vue?vue&type=template&id=bd2bbeca"
import script from "./BusinessMembersView.vue?vue&type=script&lang=js"
export * from "./BusinessMembersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports